<template>
    <FormRadioGroup
        :label="label"
        :name="name"
        :model-value="modelValue"
        :options="yesNoOptions"
        :errors="errors"
        :hint="hint"
        :required="required"
        @update:model-value="$emit('update:modelValue', $event)"
    />
</template>

<script setup>
import FormRadioGroup from '@/components/award-bookings/request-form/form-radio-group.vue';

defineProps({
    label: { type: String, required: true },
    name: { type: String, required: true },
    modelValue: { type: [Boolean, null], default: null },
    errors: { type: Object, default: null },
    hint: { type: [String, null], default: null },
    required: { type: Boolean, default: false },
});

defineEmits(['update:modelValue']);

const yesNoOptions = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
];
</script>
